module.exports = __webpack_public_path__ + "img/leijishu.e9e9bbaf.jpg";